import { style } from '@vanilla-extract/css';

export const baseContainer = style({
  display: 'flex',
  gap: 'var(--gap)',
  flexDirection: 'var(--flex-direction)',
  alignItems: 'center',
  justifyContent: 'center',

  '@media': {
    'only screen and (--mobile)': {
      flexDirection: 'var(--mobile-flex-direction)',
      gap: 'var(--mobile-gap)',
    },
  },
});
